// import react from "react";

// const exteriorImages = [
//   { src: "/public/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg", caption: "Building Exterior" },
//   { src: "/Gallerypics/image2.jpg", caption: "Factory Painting" },
//   {src:'/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg', caption: "Factory Painting"},
//   { src: '/Gallerypics/51af35d219d4ee84b5507f4680d57c9f.jpg',caption: "Factory Painting"},
//   { src:'/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg',caption: "Factory Painting"},
//    {src: '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',caption: "Factory Painting"},
//    {src: '/Gallerypics/tennis-court-render-3d-illustration.jpg',caption: "Factory Painting"},
//    {src: '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',caption: "Factory Painting"},
//    {src:   '/Gallerypics/Javed.jpg',caption: "Factory Painting"},
//    {src:   '/Gallerypics/Servicepics/photo-1454165804606-c3d57bc86b40.jpeg',caption: "Factory Painting"},
//    {src:   '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',caption: "Factory Painting"},
//    {src:   '/Gallerypics/tennis-court-render-3d-illustration.jpg',caption: "Factory Painting"},
//    {src:   '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',caption: "Factory Painting"},
//    {src:   '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',caption: "Factory Painting"},
//    {src:   '/Gallerypics/tennis-court-render-3d-illustration.jpg',caption: "Factory Painting"},
//    {src:   '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',caption: "Factory Painting"},
//   // more images
// ];


// import React, { useState,useEffect } from "react";
// import Lightbox from "yet-another-react-lightbox";
// import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
// import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
// import "yet-another-react-lightbox/styles.css";
// import AOS from "aos";
//  import "aos/dist/aos.css";


// export default function GalleryImage({ images = [], startIndex = 0 }) {
//   const [open, setOpen] = useState(false);
//   const [index, setIndex] = useState(startIndex);

//   useEffect(() => {
//     AOS.init({ duration: 1000 });
//   }, []);
//   const animations = ['fade-down',"fade-up", "fade-right", "fade-left"];

//   const handleOpen = (i) => {
//     setIndex(i);
//     setOpen(true);
//   };

//   return (
//     <>
//       <div
//          style={{
//            columnCount: 3,
//            columnGap: "1rem",
//            padding: "20px",
//          }}
//        >
//          {images.map((img, i) => (
//           <div
//             key={i}
//             // data-aos="fade-up"
//             data-aos={animations[i % animations.length]}
//             data-aos-delay={i * 100}
//             style={{
//               breakInside: "avoid",
//               overflow: "hidden",
//               borderRadius: "8px",
//               marginBottom: "1rem",
//               cursor: "pointer",
//               boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//               transition: "transform 0.3s ease",
//             }}
//             onClick={() => handleOpen(i)}
//             className="gallery-item"
//           >
//             <img
//               src={img.src}
//               alt={img.alt || `Gallery image ${i + 1}`}
//               style={{
//                 width: "100%",
//                 display: "block",
//                 aspectRatio: "16 / 9", /* Maintain 16:9 ratio */
//                 objectFit: "cover",
//                 borderRadius: "8px",
//                 transition: "transform 0.3s ease",
//               }}
//               className="gallery-img"
//             />
//           </div>
//         ))}
//       </div>
//     {/* Lightbox */}
//     <Lightbox
//         open={open}
//         close={() => setOpen(false)}
//         index={index}
//         slides={images.map((img) => ({
//           src: img.src,
//           title: img.caption,
//         }))}
//         plugins={[Fullscreen, Slideshow]}
//       />

//       {/* Hover effect via CSS */}
//       <style>{`
//         .gallery-item:hover img {
//           transform: scale(1.05);
//           filter: brightness(0.9);
//         }
//        `}</style>
//      </>
//   );
//  } 

import React, { useState, useEffect } from "react";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import "yet-another-react-lightbox/styles.css";
import AOS from "aos";
import "aos/dist/aos.css";

export default function GalleryImage({ images = [], startIndex = 0 }) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(startIndex);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const animations = ["fade-down", "fade-up", "fade-right", "fade-left"];

  const handleOpen = (i) => {
    setIndex(i);
    setOpen(true);
  };

  return (
    <>
      {/* Masonry Layout */}
      <div
        style={{
          columnCount: 3, // 4 columns desktop
          columnGap: "1rem",
          padding: "20px",
        }}
      >
        {images.map((img, i) => (
          <div
            key={i}
            data-aos={animations[i % animations.length]}
            data-aos-delay={i * 100}
            style={{
              breakInside: "avoid",
              overflow: "hidden",
              borderRadius: "8px",
              marginBottom: "1rem",
              cursor: "pointer",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease",
            }}
            onClick={() => handleOpen(i)}
            className="gallery-item"
          >
            <img
              src={img.src}
              alt={img.alt || `Gallery image ${i + 1}`}
              style={{
                width: "100%",
                display: "block",
                 // Keep 16:9 ratio
                objectFit: "cover",
                borderRadius: "8px",
                transition: "transform 0.3s ease",
              }}
              className="gallery-img"
            />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={images.map((img) => ({
          src: img.src,
          title: img.caption,
        }))}
        plugins={[Fullscreen, Slideshow]}
      />

      {/* Hover effect via CSS */}
      <style>{`
        .gallery-item:hover img {
          transform: scale(1.05);
          filter: brightness(0.9);
        }

        /* Responsive Masonry */
        @media (max-width: 1024px) {
          .gallery-wrapper {
            column-count: 3;
          }
        }
        @media (max-width: 768px) {
          .gallery-wrapper {
            column-count: 2;
          }
        }
        @media (max-width: 480px) {
          .gallery-wrapper {
            column-count: 1;
          }
        }
      `}</style>
    </>
  );
}
